import { render, staticRenderFns } from "./policy-details.vue?vue&type=template&id=10bb539c&scoped=true&"
import script from "./policy-details.vue?vue&type=script&lang=js&"
export * from "./policy-details.vue?vue&type=script&lang=js&"
import style0 from "./policy-details.vue?vue&type=style&index=0&id=10bb539c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10bb539c",
  null
  
)

export default component.exports